import urlTool from '@/tools/url';
import fetchJQueryAdapter from '@/tools/fetchJQueryAdapter';

/**
 * @memberof module:ajaxAPI/favorites
 * @alias add
 *
 * @description
 * Добавление товара в избранное
 *
 * @param {number} id - id товара, добавляемого в сравнение
 *
 * @return {$.ajax}
 *
 * @example
 * ajaxAPI.favorites.add(123456)
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */

export default function(id) {
  let lang = urlTool.getKeyValue('lang') || '';
  let fields = {
    lang: lang,
    product: {
      id: parseInt(id)
    }
  };

  return fetchJQueryAdapter('/front_api/favorites.json',
    {
      method: 'POST',
      body: JSON.stringify(fields),
      headers: { 'Content-Type': 'application/json' }
    }
  );
};
